import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./AlumniLogin.css";
import "./AlumniPasswordReset.css";

const AlumniForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const nextErrors = {};

    if (!email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "/backend/alumni/send-otp",
        { email: email.trim() },
        { withCredentials: true }
      );

      if (response.data.success) {
        navigate("/alumni-password-otp", {
          state: { email: email.trim() },
        });
      } else {
        setErrors((prev) => ({
          ...prev,
          form: response.data.message || "Failed to send OTP",
        }));
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to send OTP. Please try again.";
      setErrors((prev) => ({
        ...prev,
        form: message,
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="alumni-login-page">
      <div className="alumni-login-card">
        <h1 className="alumni-login-title"> Forgot Password</h1>
        <div className="alumni-login-line"></div>

        <p className="alumni-reset-helper">
          Enter your registered email address. We will send an OTP to verify the reset request.
        </p>

        {errors.form && <p className="alumni-page-message error">{errors.form}</p>}

        <form onSubmit={handleSubmit}>
          <div className="alumni-input-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors((prev) => ({ ...prev, email: "", form: "" }));
              }}
              aria-invalid={Boolean(errors.email)}
            />
            {errors.email && <p className="alumni-field-error">{errors.email}</p>}
          </div>

          <button type="submit" className="alumni-login-btn" disabled={loading}>
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>

          <div className="alumni-register-text">
            Remembered your password? <Link to="/alumni-login">Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AlumniForgotPassword;
